import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface MenuCollapseModel {
    active: boolean;
}

const initialState:MenuCollapseModel = {
    active: false
}

const menuSlice = createSlice({
    name: "menu",
    initialState: initialState,
    reducers: {
        showMenu: (state) => {
            state.active = false;
        },
        hideMenu: (state) => {
            state.active = true;
        }
    }
});

export const menuState = (state: RootState) => state.menu;
export const { hideMenu, showMenu } = menuSlice.actions;
export default menuSlice.reducer;